export const getAllActionFlowVariables = (flow) => {
    if (!flow?.actions) {
        return [];
    }

    return flow.actions.map(action => {
        if (action?.flowVariables) {
            return (
                <li key={action.name}>
                    <strong>{action.name}:</strong> 
                    <ul>
                        {action.flowVariables.map(fv => (
                            <li key={fv.name}>
                               <b> Name:</b> {fv.name} | <b> Value:</b> {fv.value} | <b> Behavior:</b>{fv.behavior} | <b> Property:</b>{fv.instruction}
                            </li>
                        ))}
                    </ul>
                </li>
            );
        }
        return null; // Avoid returning undefined if no flowVariables
    });
};
